import { FunctionComponent, ReactNode } from "react";
import "./style.scss";

export interface Props {
  arrowPosition: "downRight";
  backgroundColor: "tertiaryBlue48";
  children: ReactNode;
  position: { bottom?: string; left?: string; right?: string; top?: string };
}

const TooltipSmily: FunctionComponent<Props> = ({
  arrowPosition,
  backgroundColor,
  children,
  position,
}) => {
  return (
    <div
      className={`TooltipSmily TooltipSmily--backgroundColor-${backgroundColor} TooltipSmily--position-${arrowPosition}`}
      style={position}
    >
      {children}
    </div>
  );
};

export default TooltipSmily;
